/**
 * @generated SignedSource<<91dfebfa01af968d79ebe7807a517470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EndMeeting_note$data = {
  readonly event: {
    readonly isOrganizer: boolean | null;
  } | null;
  readonly id: string;
  readonly stream: {
    readonly isMeetingFeedbackPromptEnabled: boolean;
  };
  readonly " $fragmentType": "EndMeeting_note";
};
export type EndMeeting_note$key = {
  readonly " $data"?: EndMeeting_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"EndMeeting_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EndMeeting_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isOrganizer",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMeetingFeedbackPromptEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "273ecf6a0c83ad0a956f2f595feec4ac";

export default node;
